import styles from "./DataProt.module.css"
import Footer from "../../components/Footer/Footer";

export default function DataProt(){
    document.title = "Datenschutzerklärung - Alwinowitch"
    return (
        <div className={styles.wrapper}>
        <div className={`${styles.container} container`}>
          <h1 className="mb-4 mt-5">Datenschutzerklärung</h1>

          <h5>1. Allgemeine Hinweise</h5>
          <p>
            Der Schutz Ihrer persönlichen Daten ist uns wichtig. Die Nutzung dieser Website ist in der Regel ohne Angabe personenbezogener Daten möglich. Sofern auf unserer Seite personenbezogene Daten (wie Name, Adresse oder E-Mail-Adresse) erhoben werden, erfolgt dies auf freiwilliger Basis und wird nur genutzt, um auf Ihre Anfrage zu antworten oder Ihnen einen Service zur Verfügung zu stellen.
          </p>

          <h5>2. Verantwortlicher</h5>
          <p>
            Alwin Berger<br />
            Bautzener Straße 5<br />
            02730 Ebersbach-Neugersdorf<br />
            E-Mail: <a href="mailto:alwinb22005@gmail.com">alwinb22005@gmail.com</a>
          </p>

          <h5>3. Zugriffsdaten (Server-Logs)</h5>
          <p>
            Der Hosting-Anbieter dieser Website erhebt automatisch Informationen in sogenannten Server-Logfiles (z. B. IP-Adresse, Browser, Uhrzeit), die notwendig sind, um die Website betriebsbereit zu halten und die Nutzung der Website zu analysieren. Diese Daten werden nicht mit anderen personenbezogenen Daten kombiniert und dienen nur statistischen Zwecken sowie der Optimierung unserer Website.
          </p>

          <h5>4. Einbindung von Diensten Dritter</h5>
          <p>Diese Seite bindet Inhalte folgender Drittanbieter ein:</p>
          <ul>
            <li><strong>YouTube</strong> (Google Ireland Ltd.) – <a href="https://policies.google.com/privacy" target="_blank">Datenschutz</a></li>
            <li><strong>YouTube Music</strong> (Google Ireland Ltd.) – <a href="https://policies.google.com/privacy" target="_blank">Datenschutz</a></li>
            <li><strong>Spotify</strong> (Spotify AB) – <a href="https://www.spotify.com/de/legal/privacy-policy/" target="_blank">Datenschutz</a></li>
            <li><strong>SoundCloud</strong> (SoundCloud Limited) – <a href="https://soundcloud.com/pages/privacy" target="_blank">Datenschutz</a></li>
            <li><strong>Instagram / Facebook</strong> (Meta Platforms Ireland Ltd.) – <a href="https://www.facebook.com/privacy/policy" target="_blank">Datenschutz</a></li>
            <li><strong>TikTok</strong> (TikTok Technology Ltd.) – <a href="https://www.tiktok.com/legal/privacy-policy-eea?lang=de" target="_blank">Datenschutz</a></li>
            <li><strong>Amazon Music</strong> (Amazon Europe Core S.à r.l.) – <a href="https://www.amazon.de/gp/help/customer/display.html?nodeId=GX7NJQ4ZB8MHFRNJ" target="_blank">Datenschutz</a></li>
            <li><strong>Apple Music</strong> (Apple Distribution International Ltd.) – <a href="https://www.apple.com/legal/privacy/de-ww/" target="_blank">Datenschutz</a></li>
          </ul>

          <p>Diese Anbieter können Ihre IP-Adresse erfassen und Cookies setzen, um personalisierte Inhalte und Werbung anzuzeigen.</p>

          <h5>5. Keine personenbezogenen Daten</h5>
          <p>
            Diese Website erhebt keine personenbezogenen Daten wie Name, Adresse oder E-Mail-Adresse, außer wenn dies ausdrücklich durch den Nutzer erfolgt (z. B. durch das Absenden einer E-Mail über die Kontaktadresse). Es werden keine Cookies gesetzt und keine personenbezogenen Daten zu Analysezwecken gesammelt.
          </p>

          <h5>6. Ihre Rechte</h5>
          <p>
            Sie haben jederzeit das Recht auf Auskunft, Berichtigung, Sperrung oder Löschung Ihrer personenbezogenen Daten. Wenn Sie der Meinung sind, dass Ihre Daten unrechtmäßig verarbeitet werden, können Sie sich an die zuständige Datenschutzbehörde wenden.
          </p>

          <h5>7. Kontakt zum Datenschutz</h5>
          <p>
            Bei Fragen zum Datenschutz können Sie sich jederzeit an die im Impressum genannte Kontaktadresse wenden.
          </p>
        </div>
        <Footer bgColor={"lightgrey"} fontColor={"black"}/>
        </div>
    );
}